export class PasswordChange {
  currentPassword: string;
  newPassword: string;
}
